// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_HfTd7","dangerous":"view-default_dangerous_3IcUQ"};